import { useContext, useState } from 'react';
import Heading from '../../ui/Heading';
import SubHeading from '../../ui/SubHeading';
import { BountiesContext } from '../../contexts/BountiesContext';
import { useNavigate } from 'react-router-dom';

import ButtonNew from '../../ui/ButtonNew';

const navData = ['Brief', 'Criteria', 'Microtasks', 'Rewards', 'Backer'];

function BountiesSideBar({ step, setStep, completedSteps, setCompletedSteps, isBackerRequired }) {
    const navigate = useNavigate();
    const handleStepClick = (targetStep) => {
        // Allow navigation only to completed steps or the current step
        if (completedSteps.includes(targetStep) || targetStep === step) {
            setStep(targetStep);

            // If going back to a previous step, remove steps after it from completedSteps
            if (targetStep < step) {
                setCompletedSteps((prev) => prev.filter((completedStep) => completedStep < targetStep));
            }
        }
    };

    return (
        <aside className="pt-14 pl-9   bg-bg700 ">
            {/* <Heading className={'text-textPrimary font-medium mb-10 '} type={'large'}>
                Project
            </Heading> */}
            <ButtonNew
                variant="neutral"
                shape="oval"
                size="xs"
                onClick={() => navigate(-1)}
                className="pb-3 pt-3  flex items-center justify-center  shadow-sm "
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <path d="M15.4199 1.125L1.91943 14.6255" stroke="#737373" strokeWidth="2.25" strokeLinecap="round" />
                    <path d="M14.625 14.625L1.12451 1.12451" stroke="#737373" strokeWidth="2.25" strokeLinecap="round" />
                </svg>
            </ButtonNew>

            <SubHeading className={'uppercase text-secondaryText mb-4 mt-14  '} type={'xsmall'}>
                Bounty Steps
            </SubHeading>

            <ul>
                {(isBackerRequired ? navData : navData.slice(0, navData?.length - 1)).map((nav, index) => {
                    const targetStep = index + 1;
                    const isStepAccessible = completedSteps.includes(targetStep) || targetStep === step;
                    return (
                        <li
                            onClick={() => handleStepClick(targetStep)}
                            className={`text-sm cursor-pointer mb-1 ${step === index + 1 ? 'text-textBrandBlue' : 'text-secondaryText'
                                }  font-bold capitalize `}
                            key={nav + index}
                        >
                            <span>{index + 1}.</span> <span>{nav}</span>
                        </li>
                    );
                })}
            </ul>
        </aside>
    );
}

export default BountiesSideBar;
